import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { PatternFormat } from 'react-number-format';
import { InsetWrapper } from '../../CheckoutProcess/components/InsetWrapper';
import { CreditCards } from '../components/CreditCards';
import { PaymentContext } from '../contexts/PaymentContext';

const modalCustomStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
};

export class AdyenCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderID: '',
      number: '',
      expMonth: '',
      expYear: '',
      ccv: '',
      zip: '',
      address: {
        name: this.props.name,
        address: this.props.defaultAddress.address,
        address2: this.props.defaultAddress.address2,
        city: this.props.defaultAddress.city,
        state: this.props.defaultAddress.state,
        country: this.props.defaultAddress.country,
        zip: this.props.defaultAddress.zip,
        phone: this.props.phone,
      },
      loading: false,
      cardinalCommerceData: '',
      show3DSmodal: false,
      modalContent: '',
    };
  }

  onSuccess = () => {
    this.setState({ loading: false });
  };

  onError = () => {
    this.setState({ loading: false });
  };

  onNumberChange = (e) => {
    this.setState({ number: e.target.value });
  };

  onMonthChange = (e) => {
    this.setState({ expMonth: e.target.value });
  };

  onYearChange = (e) => {
    this.setState({ expYear: e.target.value });
  };

  onCCVChange = (e) => {
    this.setState({ ccv: e.target.value });
  };

  onZipChange = (e) => {
    let address = { ...this.state.address };
    address.zip = e.target.value;
    this.setState({ zip: e.target.value, address });
  };

  onAddressChange = (address) => {
    this.setState({ address });
  };

  submitPayment = (threeDSData = null) => {
    if (this.state.loading === true) {
      // Empty ??
    } else {
      this.setState({ loading: true });
    }
    if (this.props.isFullyPaid) {
      return;
    }

    this.props.onPaymentInitiated();

    let cardNumber = this.state.number.replace(/\s+/g, '');
    let payload = {
      name: this.state.address.name,
      number: cardNumber,
      expiration_month: this.state.expMonth,
      expiration_year: this.state.expYear,
      security_code: this.state.ccv,
      ...this.state.address,
      amount: this.props.amount,
      email: this.props.email,
      tos_accepted: this.props.tosAccepted,
      captureMethod: this.props.captureMethod,
      emailOptOut: this.props.emailOptOut,
      leapOptIn: this.props.leapOptIn,
      card_token: threeDSData,
      reservationToken: this.props.token,
    };

    if (this.props.createdNewAccount) {
      payload.sendAccountEmail = 1;
    }

    //if we don't have 3DS Data - try to make 3DS request
    if (threeDSData === null) {
      this.threeDSRequest(this.props.token, 'payment', payload, this.props.secret)
        .then((result) => {
          this.setState({ loading: false });

          let jsonData = '';
          try {
            jsonData = JSON.parse(result.text);
          } catch (e) {
            return;
          }
          if (typeof jsonData.action !== 'undefined' && jsonData.action === '3ds') {
            this.setState({
              show3DSmodal: true,
              modalContent: jsonData.html,
            });
            return;
          } else {
            //if we have no action - submit
            this.reservationMakeRequest(payload);
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          if (error.response && error.response.body) {
            this.props.onPaymentFail(error.response.body.errors);
          } else {
            this.props.onPaymentFail(error);
          }
        });
    } else {
      //if we have 3DS response - submit
      this.reservationMakeRequest(payload);
    }
  };

  reservationMakeRequest(payload) {
    this.props.onPaymentSubmit(payload, { onSuccess: this.onSuccess, onError: this.onError });
  }

  threeDSRequest(reservation_id, type, payload, reservation_secret) {
    return this.props.onThreeDSRequest({
      reservation_id,
      type,
      payload,
      reservation_secret,
    });
  }

  componentDidMount() {
    Modal.setAppElement('#body');
    let genericErrorMessage = 'Error submitting payment';

    ///adds event listener
    let eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    let eventer = window[eventMethod];
    let messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;
    eventer(messageEvent, function (e) {
      if (e.origin !== that.props.originUrl) return;

      if (e.data.length) {
        let dataDecoded = JSON.parse(e.data);
        if (typeof dataDecoded.threeDSWindowResult !== 'undefined') {
          that.setState(
            {
              show3DSmodal: false,
              modalContent: '',
            },
            that.submitPayment(JSON.stringify(dataDecoded.threeDSWindowResult)),
          );
        }
      }
    });
  }

  render() {
    return (
      <PaymentContext.Consumer>
        {({ TranslationContext, LocalizedAddress }) => (
          <TranslationContext.Consumer>
            {(t) => (
              <section className="checkout-form__section">
                <h4 className="checkout-form__sub-heading checkout-form__credit-card__sub-heading">
                  <div className="flex-left">{t.t('checkout__credit_card_details')}</div>
                  <div className="flex-right">
                    <CreditCards acceptedCards={this.props.acceptedCards} />
                  </div>
                </h4>
                <form id="payment-submit-form" onSubmit={this.submitPayment}>
                  <InsetWrapper>
                    <div className="input__top">
                      <label className="input__label" htmlFor="card__input-number">
                        {t.t('checkout__card_number')}
                      </label>
                    </div>
                    <PatternFormat
                      format="#### #### #### ####"
                      type="tel"
                      id="card__input-number"
                      required
                      className="input__control card__input card__input-number"
                      placeholder="Card Number"
                      pattern="[0-9 ]{14,23}"
                      autoComplete="cc-number"
                      name="number"
                      value={this.state.number}
                      onChange={this.onNumberChange}
                    />
                  </InsetWrapper>
                  <div className="row card__input-group">
                    <div className="col-sm-6">
                      <div className="card__input-date-group">
                        {/* <label htmlFor="exp" className="input__label">Expiration Date</label> */}
                        <div className="card__input-date">
                          <div className="card__input-month">
                            <InsetWrapper>
                              <label htmlFor="card__input-month" className="input__label">
                                MM
                              </label>
                              <input
                                type="tel"
                                id="card__input-month"
                                required
                                className=" input__control card__input"
                                placeholder="MM"
                                pattern="[0-9]{1,2}"
                                autoComplete="cc-exp-month"
                                name="expiration_month"
                                value={this.state.expMonth}
                                onChange={this.onMonthChange}
                                maxLength="2"
                              />
                            </InsetWrapper>
                          </div>
                          <span className="card__date-text"> / </span>
                          <div className="card__input-year">
                            <InsetWrapper>
                              <label htmlFor="card__input-year" className="input__label">
                                YYYY
                              </label>
                              <input
                                type="tel"
                                id="card__input-year"
                                required
                                className="input__control card__input card__input-date"
                                placeholder="YYYY"
                                pattern="[0-9]{2,4}"
                                autoComplete="cc-exp-year"
                                name="expiration_year"
                                value={this.state.expYear}
                                onChange={this.onYearChange}
                                maxLength="4"
                              />
                            </InsetWrapper>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card__input-cvc">
                        <InsetWrapper>
                          <label className="input__label" htmlFor="card__input-cvc">
                            {t.t('checkout__cvc_code')}
                          </label>
                          <input
                            type="tel"
                            id="card__input-cvc"
                            required
                            className="input__control card__input card__input_cvc"
                            placeholder="CVC Code"
                            autoComplete="cc-cvc"
                            name="security_code"
                            value={this.state.ccv}
                            maxLength="4"
                            inputMode="numeric"
                            pattern="[0-9]{3,4}"
                            onChange={this.onCCVChange}
                          />
                        </InsetWrapper>
                      </div>
                    </div>
                  </div>
                  <button
                    style={{ display: 'none' }}
                    id="payment-form-invisible-button"
                    onClick={this.onPaymentButtonClick}
                    type="submit"
                  >
                    Invisible display button
                  </button>
                </form>
                <LocalizedAddress
                  {...this.state.address}
                  onAddressChange={this.onAddressChange}
                  header={t.t('checkout__billing_address')}
                />
                <Modal
                  isOpen={this.state.show3DSmodal}
                  shouldCloseOnEsc={false}
                  style={modalCustomStyles}
                  onAfterOpen={this.onModalOpen}
                >
                  <iframe
                    id="adyenIframe"
                    style={{ width: '100%', height: '100%', minWidth: '400px', minHeight: '500px' }}
                  />
                </Modal>
              </section>
            )}
          </TranslationContext.Consumer>
        )}
      </PaymentContext.Consumer>
    );
  }

  onModalOpen = () => {
    let doc = document.getElementById('adyenIframe').contentWindow.document;
    doc.open();
    doc.write(this.state.modalContent);
    doc.close();
  };

  onPaymentButtonClick = (e) => {
    e.preventDefault();
    this.submitPayment();
  };
}

AdyenCreditCard.propTypes = {
  onPaymentInitiated: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  onPaymentFail: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phone: PropTypes.string,
  token: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  acceptedCards: PropTypes.object,
  captureMethod: PropTypes.number,
  isFullyPaid: PropTypes.bool,
  createdNewAccount: PropTypes.bool,
  emailOptOut: PropTypes.bool,
  leapOptIn: PropTypes.bool,
  originUrl: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
  clientKey: PropTypes.string.isRequired,
  defaultAddress: PropTypes.object.isRequired,
};

AdyenCreditCard.defaultProps = {
  phone: '',
  name: '',
  acceptedCards: {},
  captureMethod: 1, // CAPTURE_ONLINE
  defaultAddress: {},
};

export default AdyenCreditCard;
